import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {ConfirmationPinConfiguration} from './types'

export const buildConfirmationPinConfiguration = ({
  inputProps: {confirmationPinRequired},
  featureToggles: {enableConfirmationPin}
}: BuildConfigurationInput): ConfirmationPinConfiguration => {
  return {
    confirmationPin: {
      confirmationPinRequired,
      enableConfirmationPin
    }
  }
}
